import { usePrintCheck } from "./usePrintCheck";

export const DontPrint = ({ children }) => {
    const printing = usePrintCheck();

    if (printing) return null;
    return children;
};
